import {
  DesignTokenSizeEnum,
  styled,
} from '@volkswagen-onehub/components-core';

interface StyledDataListProps {
  rowCount: number;
}

export const StyledDataList = styled.div.withConfig<StyledDataListProps>({
  shouldForwardProp: (prop) => !['rowCount'].includes(prop),
})(
  ({ rowCount, theme }) => `
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: repeat(${rowCount}, 1fr);
    grid-column-gap:  ${theme.size[DesignTokenSizeEnum.static250]};
    grid-row-gap: 0;

    *:nth-child(odd) {
      padding-right:  ${theme.size[DesignTokenSizeEnum.static250]};
    }
`
);
